import { render } from "./Navbar.vue?vue&type=template&id=7c825e71&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=7c825e71&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/vueApps/ronchipiero.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c825e71"]])

export default __exports__